export function isUngroupedColor(
  groupName: string,
  colorName: string,
): boolean {
  return groupName === colorName;
}

export function buildTokenPath(
  groupName: string,
  colorName: string,
  isDark = false,
): string {
  const basePath = isUngroupedColor(groupName, colorName)
    ? colorName
    : `${groupName}/${colorName}`;
  return isDark ? `dark-${basePath}` : basePath;
}

export const parseColorName = (fullName: string) => {
  const parts = fullName.split("/");
  if (parts.length === 2) {
    return {
      groupName: parts[0].trim(),
      colorName: parts[1].trim(),
    };
  }
  return {
    groupName: fullName.trim(), // For ungrouped colors, groupName === colorName
    colorName: fullName.trim(),
  };
};
